/**
 * @generated SignedSource<<2321d8c359de447c8c0e6c36ac7aec40>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BusinessBoard_withWorkflow_view$data = {
  readonly groupByConfig: {
    readonly fieldId: string;
  };
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"BoardContentOld_view" | "BoardContent_view" | "BoardDataProvider_view" | "BoardFieldIdsProvider_view" | "BoardHeader_view" | "BusinessBoardScreenAnalytics_view" | "IssuesByGroupProviderOld_view" | "IssuesByGroupProvider_view">;
  readonly " $fragmentType": "BusinessBoard_withWorkflow_view";
};
export type BusinessBoard_withWorkflow_view$key = {
  readonly " $data"?: BusinessBoard_withWorkflow_view$data;
  readonly " $fragmentSpreads": FragmentRefs<"BusinessBoard_withWorkflow_view">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcallowstatusmappingonbusinessboardrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "BusinessBoard_withWorkflow_view",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "BoardDataProvider_view"
    },
    {
      "kind": "FragmentSpread",
      "name": "BoardHeader_view"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcallowstatusmappingonbusinessboardrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "BoardContent_view"
        },
        {
          "kind": "FragmentSpread",
          "name": "IssuesByGroupProvider_view"
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcallowstatusmappingonbusinessboardrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "BoardContentOld_view"
        },
        {
          "kind": "FragmentSpread",
          "name": "IssuesByGroupProviderOld_view"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "BusinessBoardScreenAnalytics_view"
    },
    {
      "kind": "FragmentSpread",
      "name": "BoardFieldIdsProvider_view"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraViewGroupByConfig",
        "kind": "LinkedField",
        "name": "groupByConfig",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "fieldId"
            },
            "action": "THROW",
            "path": "groupByConfig.fieldId"
          }
        ]
      },
      "action": "THROW",
      "path": "groupByConfig"
    }
  ],
  "type": "JiraBoardView"
};

(node as any).hash = "1854c1abc85e7f11d506aadedffe06d7";

export default node;
